import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_ACTIVE_VIEW } from "../../../../constants/actions";
import styles from "./AddFavouritesHeader.module.scss";
import FilterHeaderButton from "../../../../layouts/Filter/components/FilterHeaderButton";
import { sendAnalyticsEvent, sendMessage } from "../../../../lib/postMessage";
import { isValidName } from "../../../../lib/string";
import { generateFavouriteId } from "../../../../lib/favourites";
import { FavouritesHeader } from "../../../../components/FavouritesHeader";
import {
  ALL,
  CLEAR,
  CLOSE,
  CREATE,
  FAVOURITES,
  FAVOURITES_ANALYTICS_VIEW,
} from "../../../../constants/analytics";

export const AddFavouritesHeader = () => {
  const dispatch = useDispatch();
  const { storedFavourites } = useSelector((state) => state.filter);
  const { name, odds, markets } = useSelector((state) => state.favourites);
  const { previousView } = useSelector((state) => state.view);
  const clearAllIsDisabled =
    (odds.minOdds === undefined || odds.minOdds === null) &&
    (odds.maxOdds === undefined || odds.maxOdds === null) &&
    markets.length === 0;
  const isDisabled =
    !name ||
    !isValidName(name) ||
    (!odds.minOdds && !odds.maxOdds && markets.length === 0);

  const resetFavouriteValues = () => {
    dispatch({
      type: "RESET_FAVOURITE_OPTIONS",
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: ALL,
      action: CLEAR,
    });
  };

  const clearAll = useCallback(() => {
    dispatch({
      type: "CLEAR_ALL_FAVOURITES_SELECTIONS",
    });
  }, [dispatch]);

  const storeNewFavourite = () => {
    sendMessage({
      type: "UpdateFavourites",
      payload: [
        ...storedFavourites,
        {
          id: generateFavouriteId(storedFavourites),
          name,
          odds,
          markets,
        },
      ],
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type: ALL,
      action: CREATE,
    });

    dispatch({
      type: SET_ACTIVE_VIEW,
      payload: previousView ?? "",
    });
  };

  useEffect(() => {
    return () => {
      clearAll();
    };
  }, [clearAll]);

  const closeFilter = () => {
    clearAll();
    dispatch({
      type: SET_ACTIVE_VIEW,
      payload: previousView,
    });

    sendAnalyticsEvent({
      type: FAVOURITES_ANALYTICS_VIEW,
      action: CLOSE,
    });
  };

  return (
    <>
      <FavouritesHeader heading="Add Favourites" close={closeFilter}>
        <div className={styles["filterHeaderContainer--buttons"]}>
          <FilterHeaderButton
            name="Clear all"
            ariaLabel="Clear all selections"
            onClick={resetFavouriteValues}
            disabled={clearAllIsDisabled}
          />
          <FilterHeaderButton
            name="Add"
            ariaLabel="Add to favourites"
            onClick={storeNewFavourite}
            disabled={isDisabled}
          />
        </div>
      </FavouritesHeader>
    </>
  );
};
